import { render } from "./head-banner.vue?vue&type=template&id=679aebc1&scoped=true&ts=true"
import script from "./head-banner.vue?vue&type=script&lang=ts"
export * from "./head-banner.vue?vue&type=script&lang=ts"

import "./head-banner.vue?vue&type=style&index=0&id=679aebc1&lang=scss&scoped=true"

import exportComponent from "/Users/panren/Desktop/太平洋网络/discount-topics-wap-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-679aebc1"]])

export default __exports__